/* ==================================================
  客注QRコード（商品詳細・客注モード専用）
  - staff_mode_token cookie がある場合のみ実行（CStaffSession 経由）
  - .c_product-qr__code[data-qr-url] の URL を qrcode-generator で SVG 化して描画
  - ライブラリ未読込 / URL 空 / 例外時は何もしない（フェイルサイレント, spec §2.5.7）
===================================================*/

(function () {
  function renderProductQr() {
    try {
      // 客注モードでないときは生成しない（CSS でも非表示だが無駄な処理を避ける）
      if (!window.CStaffSession || !CStaffSession.getToken()) return;
    } catch (e) {
      return;
    }

    // ライブラリ未読込なら何もしない
    if (typeof qrcode === 'undefined') return;

    var containers = document.querySelectorAll('.c_product-qr__code[data-qr-url]');
    for (var i = 0; i < containers.length; i++) {
      var el = containers[i];
      var url = el.dataset.qrUrl;
      if (!url) continue; // URL 空 → 非表示のまま

      // アクセシブルネームはローカライズ済みタイトルを data 属性経由で受け取る
      // （生URLを alt にすると SR が一文字ずつ読み上げ UX が悪いため）。
      var label = el.dataset.qrLabel || '';

      try {
        var qr = qrcode(0, 'M'); // typeNumber:0 = 自動, ecLevel:M
        qr.addData(url);
        qr.make();
        // margin:0 でライブラリ既定のクワイエットゾーン（4モジュール）を除去し、
        // QRがコンテナ幅いっぱいに描画される（余白はラッパーの灰色背景が担う＝Figma準拠）。
        // alt → role="img" + aria-labelledby（見出しを読み上げ）。
        el.innerHTML = qr.createSvgTag({ scalable: true, margin: 0, alt: label || url });
      } catch (e) {
        // 生成失敗時は空のまま（フェイルサイレント）
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderProductQr);
  } else {
    renderProductQr();
  }

  // テーマエディタでのセクション再描画に追従
  document.addEventListener('shopify:section:load', renderProductQr);
})();
